<template>
<div class="chapter">
<div class="inner_page">
<p class="p_toc_heading" id="tableofcontents">Table of Contents</p>
<p class="p_toc_entry_"><a href="#/OPS/section0002#auto_bookmark_toc_1">Blurb</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0003#auto_bookmark_toc_1">Chapter 1</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0004#auto_bookmark_toc_1">Chapter 2</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0005#auto_bookmark_toc_1">Chapter 3</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0006#auto_bookmark_toc_1">Chapter 4</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0007#auto_bookmark_toc_1">Chapter 5</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0008#auto_bookmark_toc_1">Chapter 6</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0009#auto_bookmark_toc_1">Chapter 7</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0010#auto_bookmark_toc_1">Chapter 8</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0011#auto_bookmark_toc_1">Chapter 9</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0012#auto_bookmark_toc_1">Epilogue</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0013#auto_bookmark_toc_1">More from Andrew Grey</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0014#auto_bookmark_toc_1">Readers love Fire and Flint by Andrew Grey</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0015#auto_bookmark_toc_1">About the Author</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0016#auto_bookmark_toc_1">By Andrew Grey</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0017">Visit Dreamspinner Press</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0018#auto_bookmark_toc_1">Copyright</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0001.vue?56519555